function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 2,
  x2: 12,
  y2: 6
});
var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 18,
  x2: 12,
  y2: 22
});
var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 4.93,
  y1: 4.93,
  x2: 7.76,
  y2: 7.76
});
var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 16.24,
  y1: 16.24,
  x2: 19.07,
  y2: 19.07
});
var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 2,
  y1: 12,
  x2: 6,
  y2: 12
});
var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 18,
  y1: 12,
  x2: 22,
  y2: 12
});
var _ref8 = /*#__PURE__*/React.createElement("line", {
  x1: 4.93,
  y1: 19.07,
  x2: 7.76,
  y2: 16.24
});
var _ref9 = /*#__PURE__*/React.createElement("line", {
  x1: 16.24,
  y1: 7.76,
  x2: 19.07,
  y2: 4.93
});
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-loader",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.37000a78074176dcb69efdee285f008a.svg";
export { ForwardRef as ReactComponent };